import { MenuItem, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { BehaviorSubject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import styled from 'styled-components';

import SearchResult from './SearchResult';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export default function Suggestions({
  query,
  getItemProps,
  search,
}: {
  query: string | null;
  getItemProps: any;
  search: any;
}): any {
  const [results, setResults] = useState<SearchResult<any>[]>();
  const querySubject = useMemo(() => new BehaviorSubject(query), [query]);

  useEffect(() => {
    if (query !== querySubject.value) {
      querySubject.next(query);
    }
  }, [query, querySubject]);

  useEffect(() => {
    const onQueryChange = querySubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        map(query => String(query)),
        tap(() => setResults(undefined)),
        filter(query => query.length > 0),
        switchMap(search)
      )
      .subscribe(setResults);

    return () => onQueryChange.unsubscribe();
  }, [querySubject, search]);

  if (!results) {
    return null;
  }

  return results.map((item, index) => (
    <MenuItem key={index} {...getItemProps({ item })}>
      <Container>
        <div>
          <Typography>{item.title}</Typography>

          {item.subtitle && (
            <Typography color="textSecondary" variant="body2">
              {item.subtitle}
            </Typography>
          )}
        </div>

        {item.provider && (
          <Typography color="textSecondary" variant="overline">
            {item.provider}
          </Typography>
        )}
      </Container>
    </MenuItem>
  ));
}
